export default __webpack_public_path__ + "static/media/puzzle-white.e26f81ef.svg";